// Shared date-formatting helpers for partner microsite copy.
//
// Never format a partner date via a bare `new Date(isoString)`: an
// ISO-date-only string (e.g. "2026-10-16") is parsed as UTC midnight, which
// renders as the previous day once formatted in a US (negative UTC offset)
// timezone. Split the string and build the Date from local Y/M/D
// components instead, as both helpers below do.

const parseIsoDateParts = (isoDate: string): [number, number, number] => {
  const [year, month, day] = isoDate.split('-').map(Number)
  return [year, month, day]
}

// "2026-10-17" -> "10/17/2026"
export const toNumericDate = (isoDate: string): string => {
  const [year, month, day] = parseIsoDateParts(isoDate)
  return `${month}/${day}/${year}`
}

// "2026-10-16" -> "October 16"
export const formatPartnerDateLong = (isoDate: string): string => {
  const [year, month, day] = parseIsoDateParts(isoDate)
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
  })
}
